import {inject} from "@angular/core";
import {ApyreAuthService} from "projects/portal/src/app/firebase-services";
import {CanMatchFn, Router} from "@angular/router";
import {map} from "rxjs";

export const authenticationGuard: CanMatchFn = () => {
    const authSvc: ApyreAuthService = inject(ApyreAuthService);
    const router: Router = inject(Router);
    return authSvc.settledUser$.pipe(
        map((user) => user ? true : router.createUrlTree(['/login'])),
    );
};
